const navLanguages = {
  da: "Danish",
  nl: "Dutch",
  en: "English",
  fr: "French",
  de: "German",
  hu: "Hungarian",
  it: "Italian",
  no: "Norwegian",
  pl: "Polish",
  pt: "Portuguese",
  ro: "Romanian",
  ru: "Russian",
  es: "Spanish",
  sv: "Swedish",
  "zh-CN": "Chinese",
  el: "Greek",
  tr: "Turkish",
  ar: "Arabic",
  so: "Somali",
  ku: "Kurdish",
  sq: "Albanian",
  uk: "Ukrainian",
  vi: "Vietnamese",
  cym: "Welsh",
  ja: "Japanese",
  sr: "Serbian",
  lv: "Latvian",
  ind: "Indonesian",
  ur: "Urdu",
  ta: "Tamil",
  bn: "Bengali",
};

export default navLanguages;
